module.exports = __webpack_public_path__ + "img/ing_bj_bs@2x.814eea04.png";